import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Profile.css';

const Profile = (props) => {
    const navigator = useNavigate();
    const [description,setdescription] = useState(null);
    const [optionOne,setone] = useState(null);
    const [optionTwo,settwo] = useState(null);
    const sendLogout = () => {
            fetch('https://plum-breakable-swordfish.cyclic.app/organizer/logout',{
                method: 'GET',
                credentials:'include'
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            console.log(data);
            props.settoken(null);
            props.setemail(null);
            navigator('/')
        })
        .catch(err => {
            console.error(err);
        })
    }

    const addquestion = () => {
        fetch('https://plum-breakable-swordfish.cyclic.app/organizer/question',{
            method: 'POST',
            body: JSON.stringify({
                description: description,
                optionOne: optionOne,
                optionTwo: optionTwo
            }),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            console.log(data);
        })
        .catch(err => {
            console.error(err);
        })
    }
    return (
        <div className='containerProfile'>
            <div className='profileAbout'>
           
                <div>
                    email:{props.email}
                </div>
                <button className='getReqbutton' onClick={sendLogout}>Logout</button>
               
            </div>
            <div className='profileaddQuestion'>
                <label>Question</label>
                <input className='questionInput'    onChange={(e) => {
                    setdescription(e.target.value)
                }}></input>
                <label>optionOne</label>
                <input className='questionInput'    onChange={(e) => {
                    setone(e.target.value)
                }}></input>
                <label>optionTwo</label>
                <input className='questionInput'    onChange={(e) => {
                    settwo(e.target.value)
                }}></input>
                <button className='getReqbutton' onClick={addquestion}>Submit</button>
            </div>
        </div>
    )
}

export default Profile;